<template>
  <div class="return-gift-view">
      <div class="gift-item">
          <div class="info">
              <div class="slogen s-1"></div>
              <div class="info-detail">
                <p>符合条件的回归玩家以下好礼<b>自选其四</b>，活动期间<b>只要登录游戏</b>即可全部收入囊中~</p>
                <div class="u-btn player-check" @click="player_check()"></div>
              </div>
          </div>
          <div class="gift-list">
              <ul>
                  <li v-for="(item,index) in return_gift" :key="index">
                      <div class="item" 
                      @click="$item_tips(item.giftId + '_' + item.sendNum)"
                        @mouseover="$tips_on($event,item.giftId + '_' + item.sendNum)"
                        @mouseleave="$tips_off()"                      
                      >
                        <img v-bind:src="'https://web-resource.17m3.com/m3guo/202111/a20211124back/images/icon/' + item.giftId + '_' + item.sendNum + '.jpg'" v-if="item.sendNum > 1">
                        <img v-bind:src="'https://web-resource.17m3.com/m3guo/202111/a20211124back/images/icon/' + item.giftId + '.jpg'" v-if="item.sendNum == 1">                          
                      </div>
                      <p class="item-name">{{ item.giftName }}</p>
                      <div class="radio u-btn" @click="gift_pick(index)" :class="pick_data.indexOf(index) > -1 ?'on' : ''"></div>
                  </li>
              </ul>
          </div>
          <div class="u-btn apply" @click="return_gift_apply()" v-if="!gift_apply && completed"></div>
          <div class="u-btn apply dismiss" v-else @click="rejectApply()"></div>
      </div>
      <div class="gift-item">
          <div class="info">
              <div class="slogen s-2"></div>
              <p>登录游戏，点击游戏右侧“玩家回归”按钮<img src="../images/img-btn.png">游戏中回归福利助你迅速提升，不再担心落后于人！</p>

              <div class="game-gift">
                  <ul>
                      <li v-for="(item,index) in game_gift" :key="index">
                          <div class="game-item"
                          @click="$item_tips((index+1).toString())"
                            @mouseover="$tips_on($event,(index+1).toString())"
                            @mouseleave="$tips_off()"                          
                          >
                              <img v-bind:src="'https://web-resource.17m3.com/m3guo/202111/a20211124back/images/icon/' + (index+1) + '.jpg'">
                          </div>
                      </li>
                  </ul>
              </div>
          </div>

          <div class="swiper">
              <collapse v-if="deviceType=='pc'"></collapse>
              <tab v-else></tab>
          </div>          
      </div>      
  </div>
</template>

<script>
import collapse from '@/components/collapse.vue';
import tab from '@/components/tab.vue';

export default {
    name: 'reture-gift-view',
    components: {
        'collapse' : collapse,
        'tab' : tab, 
    },
    created (){
        if(this.login && this.ua.areaId)this.task_render();
        this.get_task_info();
        //this.isMobile();
    }, 
    data () {
        return {
            pick_data : [],
            max : 4,
            return_gift : [],
            game_gift : ['1','2','3','4','5','6',],
            flag : false,
            deviceType : this.$global.deviceType,
            gift_apply : 0,
            completed : 0,
            isBacker : false,           
        }
    },
    props : {
        ua : {
            default : {},
        },
        login : {
            default : 0,
        }
    },
    methods : {
        task_render (){
            var _this = this;
            _this.$axios.get(_this.$global.ajax_url_map.task_info,{
                params: {
                    utype : 1,
                    gid : 3,
                }
            })
            .then(res => {
                if(res.data.code == 0){
                    if(!res.data.data.length)return;                   
                    var _task_info = res.data.data[0];
                    
                    this.isBacker = true;
                    this.gift_apply = _task_info.isSubmit;
                    this.completed = _task_info.isCompleted;
                }
                else{
                    _this.$toast('任务模块:' + res.data.message);
                }
            });
        },        
        gift_pick(index){
            if(this.pick_data.length == this.max){
                return this.pick_data.indexOf(index) == -1 ? this.$toast('最多只能选'+ this.max +'个哦~') : this.pick_data.remove(index);
            }

            if(this.pick_data.indexOf(index) > -1)return this.pick_data.remove(index);
            this.pick_data.push(index);
        },
        player_check (){
            var _this = this;

            if(!_this.login)return this.$mslogin.open();
            if(!_this.ua.areaId)return this.$bind();

            this.$axios.get(_this.$global.ajax_url_map.player_check)
            .then(res => {
                if(res.data.code==0){
                    _this.$check_modal({
                        is_return : res.data.data,
                        aid : _this.ua.areaId,
                        player : _this.ua.nickName,
                    });
                }
                else{
                    _this.$toast(res.data.message);
                }
            })
        },
        return_gift_apply (){
            var _this = this;

            if(!_this.login)return this.$mslogin.open();
            if(!_this.ua.areaId)return this.$bind();

            if(_this.pick_data.length != _this.max)return this.$toast('选择还不满4个~');

            var apply_list = [];
            for(var i = 0;i < _this.pick_data.length;i++){
                var _index = _this.pick_data[i];
                apply_list.push(_this.return_gift[_index].giftId);
            }
            _this.$axios.post(_this.$global.ajax_url_map.apply_return_gift,{
                taskno : 'h01',
                giftId : apply_list,
            })
            .then(res => {
                if(res.data.code==0){
                    _this.$toast('领取成功~');
                    _this.gift_apply = 1;
                }
                else{
                    _this.$toast(res.data.message);
                }
            })
        },
        get_task_info(){
            var _this = this;
            _this.$axios.get(_this.$global.ajax_url_map.task_detail,{
                params: {
                    type : 3,
                }
            })
            .then(res => {
                if(res.data.code == 0){
                    //TODO
                    _this.ready = true;
                    _this.return_gift = res.data.data[0].giftList;
                }
                else{
                    _this.$toast('任务信息模块:' + res.data.message);
                }
            });          
        },
        isMobile() {
            this.flag = navigator.userAgent.match(
                /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
            );
            if(this.flag === null) {
                console.log("pc端");
                this.deviceType = 'pc';
            }else {
                console.log("移动端");
                this.deviceType = 'mobile';
            }
        },
        rejectApply (){
            if(!this.isBacker)return this.$toast('您不是回归玩家');
            if(this.gift_apply)return this.$toast('您已领取过礼物');
            if(!this.completed)return this.$toast('登录游戏后可以领取礼物哦~');
        },                
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.info-detail b{
    color: #a2332f;
}

@media screen and (min-device-width: 1025px){
.gift-item{
    display: flex;
    margin-bottom: 50px;
}

.gift-item .info{
    width: 221px;
    color: #5c483c;
    margin-right: 75px;
}

.gift-item .info p{
    line-height: 1.8;
    padding-left: 26px;
}

.gift-item .info b{
    color: #a2332f;
}

.gift-item .slogen{
    width: 221px;
    height: 62px;
    margin-bottom: 10px;
}

.gift-item .slogen.s-1{
    background-image: url(../images/return-slogen-1.png);
}

.gift-item .slogen.s-2{
    background-image: url(../images/return-slogen-2.png);
}

.gift-list{
    width: 569px;
    padding-top: 24px;
    background-image: url(../images/bg-return-list.png);
    background-position: center top;
    background-repeat: no-repeat;
}

.gift-list ul{
    display: flex;
    justify-content: space-between;
    margin-top: 15px;
}

.gift-list .item{
    width: 83px;
    height: 80px;
    background-image: url(../images/bg-item.png);   
}

.gift-list .item-name{
    width: 83px;
    margin: 2px auto;
    color: #5c483c;
    text-align: center;
}

.gift-list .radio{
    width: 29px;
    height: 29px;
    margin: 10px auto 0;
    background-image: url(../images/radio-off.png);
}

.gift-list .radio.on{
    background-image: url(../images/radio-on.png);
}

.return-gift-view .u-btn.apply{
    width: 85px;
    height: 88px;
    margin-top: 40px;
    margin-left: 40px;
    background-image: url(../images/btn-gift.png);
}

.return-gift-view .u-btn.apply:hover{
    background-image: url(../images/btn-gift_hover.png);
}

/* todo dismiss */

.u-btn.player-check{
    width: 118px;
    height: 31px;
    margin: 20px auto 0;
    background-image: url(../images/btn-check.png);
}

.u-btn.player-check:hover{
    background-image: url(../images/btn-check_hover.png);
}

.game-gift ul{
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
    margin-left: 26px;
    justify-content: space-between;
}

.game-gift li{
    margin-bottom: 10px;
}

.game-gift .game-item{
    position: relative;
    width: 55px;
    height: 55px;
    background-image: url(../images/bg-item_2.png);
}
}

@media screen and (max-device-width: 1024px){
    .slogen.s-1{
        width: 330px;
        height: 93px;
        margin: 15px auto 5px;
        background-image: url(../images/m/label-return-1.png);
    }

    .info-detail{
        position: relative;
        margin-bottom: 35px;
        font-size: 24px;        
    }

    .info p{
        color: #5c483c;
    }

    .info-detail p{
        display: inline-block;
        padding-right: 170px;
    }

    .info p b{
        color: #a2332f;
    }

    .u-btn.player-check{
        position: absolute;
        top: 0;
        right: 0;
        width: 153px;
        height: 52px;
        margin-left: 20px;
        background-image: url(../images/m/btn-query.png);
    }
    
    .gift-list{
        width: 659px;
        padding-top: 40px;
        margin: 0 auto;
        background-image: url(../images/m/bg-return-list.png);
        background-position: center top;
        background-repeat: no-repeat;
    }

    .gift-list ul{
        display: flex;
        justify-content: space-between;
        margin-top: 15px;
    }

    .gift-list .item{
        width: 92px;
        height: 89px;
        background-image: url(../images/m/bg-item.png); 
    }

    .gift-list .item-name{
        height: 0;
        font-size: 0;
        color: transparent;
    }

    .gift-list .radio{
        width: 43px;
        height: 43px;
        margin: 10px auto 0;
        background-image: url(../images/m/radio-off.png);
    }

    .gift-list .radio.on{
        background-image: url(../images/m/radio-on.png);
    }

    .return-gift-view .u-btn.apply{
        width: 218px;
        height: 65px;
        margin: 40px auto 0;
        background-image: url(../images/m/btn-apply.png);
    }

    .slogen.s-2{
        width: 330px;
        height: 93px;
        margin: 15px auto 5px;
        background-image: url(../images/m/label-return-2.png);
    }
    
    .game-gift ul{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-top: 5px;
    }

    .game-gift li{
        margin-bottom: 10px;
    }

    .game-gift .game-item{
        position: relative;
        width: 92px;
        height: 89px;
        background-image: url(../images/m/bg-item.png); 
    }    
}

</style>



// WEBPACK FOOTER //
// src/components/return.gift.vue